export const aggridNominationTermTotalAccumulator = (terms, params) => {
  return terms.reduce((acc, nominationTerm) => {
    return (
      acc +
      (params.api.getCellValue({
        colKey: `nominationTerm.${nominationTerm.id}`,
        rowNode: params.node,
      }) || 0)
    );
  }, 0);
};
